import React from 'react';
import { motion } from 'framer-motion';
const points = [{
  icon: '🎁',
  text: 'Se venden muy bien como regalos personalizados'
}, {
  icon: '🌸',
  text: 'Son tendencia en redes por lo lindas y originales que quedan'
}, {
  icon: '💵',
  text: 'Se hacen con materiales económicos y accesibles'
}, {
  icon: '🏠',
  text: 'Podés empezar desde casa, sin taller ni gran inversión'
}];
export function Opportunity() {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden bg-[#FFFCF9]" data-id="element-153">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-154">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-12" data-id="element-155">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-6 font-bold leading-tight" data-id="element-156">
            ¿Por qué las flores eternas son una oportunidad?
          </h2>
          <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-157">
            Porque son lindas, personalizables y perfectas para regalar en
            momentos especiales. A diferencia de las flores naturales, no se
            marchitan y pueden convertirse en ramos, detalles, souvenirs,
            centros de mesa o regalos personalizados.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-12" data-id="element-158">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="rounded-2xl p-6 shadow-sm border border-deco-warm flex items-start gap-4 bg-[#FAF4EF]" data-id="element-159">
              <div className="text-3xl shrink-0" data-id="element-160">{point.icon}</div>
              <p className="text-deco-text font-medium text-base sm:text-lg leading-snug pt-1" data-id="element-161">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-deco-terra text-white py-6 px-8 rounded-[2rem] shadow-lg max-w-3xl mx-auto" data-id="element-162">
          <p className="font-serif text-xl sm:text-2xl font-bold" data-id="element-163">
            Con este kit aprendés a transformar un material simple en creaciones
            con valor.
          </p>
        </motion.div>
      </div>
    </section>;
}